//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "FailureNotes",
    data: function data() {
        return {
            failure: {},
            applicant: {},
            modalName: "Failure Notes",
            isLoading: true,
            loading: false,
            editNotes: false,
            emptyNotes: false,
            audit: {
                user: {
                    full_name: ''
                }
            },
            notesValidation: [{ model: 'failure.notes', rules: 'required' }]
        };
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('Failure Notes', function (item, audit) {
            _this.isLoading = false;
            _this.applicant = item;
            _this.failure = item.resident_identity_verification;
            _this.audit = audit;
            _this.emptyNotes = !_this.failure.notes;
            _this.$initValidator();
            Event.$emit('open-slide', _this.modalName);
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('Failure Notes');
    },

    methods: {
        close: function close() {
            Event.$emit('close-slide', this.modalName);
        },
        addNotes: function addNotes() {
            var _this2 = this;

            this.validator.setRules(this.notesValidation).validate();

            if (this.validator.fails()) {
                return;
            }
            this.loading = true;
            axios.post('/prototype/failure-add-notes', this.failure).then(function (response) {
                _this2.audit = response.data.audit;
                _this2.editNotes = false;
                _this2.loading = false;
                _this2.emptyNotes = false;
                Event.$emit("view-applicant", _this2.applicant);
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/applicants/FailureNotes.vue
// module id = ee34
// module chunks = 0 1